export const PROTECTION_PLAN_MESSAGES_SECTION_ID = 'PROTECTION_PLAN_MESSAGES_SECTION_ID';
export const PROTECTION_PLAN_MESSAGE_ID = 'PROTECTION_PLAN_MESSAGE_ID';
export const ProtectionPlanOptions = {
    no: 'no',
};
